import { FC, useEffect, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "@emotion/styled";
import { Button, Form, Input,  message } from "antd";
import { UploadImg } from "../../common/components/UploadImg";
import { useNavigate, useParams } from "react-router-dom";
import { CarBrandEntity } from "src/module/CarBrand/carBrand.entity";
import carBrandService from "src/module/CarBrand/carBrand.service";

const formItemLayout = {
	labelCol: { span: 3 },
	wrapperCol: { span: 20 },
};

export const CarBrandDetail: FC = () => {
    const [info, setInfo] = useState<CarBrandEntity>({});

    const {id} = useParams();
	const { t } = useTranslation();
    const navigate = useNavigate();

	const init = useCallback(async () => {
        if (id){
            const {data} = await carBrandService.detail(Number(id));
            setInfo(data.data);
        }
    }, [id]);

	useEffect(() => {
		init();
	}, [init]);

    const onChange = (type: string, e: any) => {
        setInfo({
            ...info,
            [type]: e
        });
    }

    const submit = async () => {
        const {data} = await carBrandService.addOrUpdate(info);

		if (data.code === 200) {
			message.success(t("success"));
			navigate("/carBrand");
		} else {
			message.error(data.msg);
		}
    }

	return (
		<Container>
			<Form>
				<Form.Item label={t("image")} {...formItemLayout}>
                    <UploadImg value={info?.image} size={"112*112"}  onChange={(e: string) => onChange("img", e)} />
                </Form.Item>
				
                <Form.Item label={t("letter")} {...formItemLayout}>
                    <Input style={{ width: "200px" }} value={info?.letter} onChange={(e: any) => onChange("letter", e.target.value)} />
                </Form.Item>
                <Form.Item label={t("brandName")} {...formItemLayout}>
                    <Input  style={{ width: "200px" }} value={info?.name} onChange={(e: any) => onChange("name", e.target.value)} />
                </Form.Item>
                <div>
                    <Button type="primary" onClick={submit}>{t("submit")}</Button>
                </div>
			</Form>
		</Container>
	);
};
const Container = styled.div`
	width: 100%;
	padding: 10px;
`;
